import {
  REQUEST_POSTS_SIMU_VEHICLE_DETAILS, RECEIVE_POSTS_SIMU_VEHICLE_DETAILS, RECEIVE_POSTS_SIMU_VEHICLES, RECEIVE_POSTS_SIMU_OPTIONS,
  RECEIVE_POSTS_SIMU_ACCESSORIES
} from '../actions/actionsApiSimulation'
import { RECEIVE_POSTS_FINANCEFILE } from '../actions/actionsApiFinanceFile'
import { RECEIVE_POSTS_VERSION, REJECT_POSTS_VERSION, RECEIVE_POSTS_ROUTINGINFO, REJECT_POSTS_ROUTINGINFO } from '../actions/actionsApi';

export const initialRoutingResponse = {};
export const initialVersionResponse = {};
export const initialResponseSimulation = {};

export function routingResponse(state, action) {
  switch (action.type) {
    case RECEIVE_POSTS_ROUTINGINFO:
      return { ...state, routingResp: action.payload };
    case REJECT_POSTS_ROUTINGINFO:
    default:
      return state
  }
}

export function versionResponse(state, action) {
  switch (action.type) {
    case RECEIVE_POSTS_VERSION:
      return { ...state, versionResp: action.payload };
    case REJECT_POSTS_VERSION:
    default:
      return state
  }
}

export function responseSimulation(state, action) {
  switch (action.type) {
    case REQUEST_POSTS_SIMU_VEHICLE_DETAILS:
      return { ...state, selectedVehicle: action.payload.vehicle };
    case RECEIVE_POSTS_SIMU_VEHICLE_DETAILS:
      if (!action.payload.isCalculator) {
        return { ...state, vehicleDetails: action.payload.responseSimulationVehicleDetails };
      }
      return state;
    case RECEIVE_POSTS_FINANCEFILE:
      return { ...state, financeFile: action.payload.responseFinanceFile };
    case RECEIVE_POSTS_SIMU_OPTIONS:
      return { ...state, optionsRental: action.payload.responseSimulationOptions };
    case RECEIVE_POSTS_SIMU_ACCESSORIES:
      return { ...state, accessoriesIncrease: action.payload.responseSimulationAccessories };
    case RECEIVE_POSTS_SIMU_VEHICLES:
      var response = { ...action.payload.responseSimulationVehicles };
      var vehiclesList = { ...action.payload.vehicles };
      var process = action.payload.process;
      if (response.vehicleResults != null) {
        var funcKeyName = (process === 'vehiclesStock' || process === 'vehiclesDefault') ? 'configurationKey' : 'lcdv16Code';
        var mapVehicles = {};
        for (var k1 in vehiclesList) {
          mapVehicles[vehiclesList[k1][funcKeyName]] = vehiclesList[k1];
        }
        for (var k2 in response.vehicleResults) {
          response.vehicleResults[k2].vehicle = mapVehicles[response.vehicleResults[k2][funcKeyName]];
        }
      }
      return { ...state, vehiclesRental: response };
    default:
      return state
  }
}
